export default [
	{
		name: 'AdminCourses',
		path: 'courses',
		component: () => import('@/pages/admin/components/course/Courses'),
	},
	{
		path: 'course/create',
		name: 'CreateCourse',
		component: () => import('@/pages/admin/components/course/CreateCourse'),
	},
	{
		path: 'course/:courseId/edit',
		name: 'EditCourse',
		component: () => import('@/pages/admin/components/course/EditCourse'),
	},
];
